import React, { Component } from 'react'
import './TipsOnDesigningMobileCover.css';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import mobileCostomize from '../../assets/images/tipsImage/mobileCostomize.JPG';


class TipsOnDesigningMobileCover extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />
                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Tips on Designing Mobile Cover</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default mb-1">Mobile Cover visuals and a few best</h2>
                        <h2 className="elementor-heading-title elementor-size-default"> combination color ink</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix bdr">
                        <p className="pg">
                            <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                Mobile cover visuals and a few best combination color ink to choose to design your own mobile cover
                            </span>
                        </p>
                         
                        <div className="mt-2">
                            <h2 className="elementor-heading-title elementor-size-default mb-1 text-center">
                                Design Your Own Custom Phone Case Online
                            </h2>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mobileCostomize} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size mb-1">
                                            How To Make A Custom Phone Case
                                        </h1>
                                        <p className="step-size">
                                            1. <b>Phone Brand</b>: Create a custom phone case by selecting the <b>Brand</b>. 
                                        </p>
                                        <p className="step-size">
                                            2. <b>Phone Model</b> : Choose the right <b>Model</b> within selected <b>Brand</b> 
                                        </p>
                                        <p className="step-size">
                                            3. <b>Choose Image</b> : Upload an image. The file types include Max file size: 5mb, accepted: jpg, gif ,and png.  
                                        </p>
                                        <p className="step-size">
                                            4. <b>Add Text/Image</b> :  Add multiple text and/ or add Image or both. The file types include Max file size: 5mb, accepted: jpg, gif ,and png.
                                        </p>
                                        <p className="step-size">
                                            5. <b>Add To Cart</b>: Select <b>Add to Cart</b> for your custom made phone case.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>      
                        </div>                            
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}
export default  TipsOnDesigningMobileCover 
